import type { ClassAttributes, HTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import type { Theme } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { type StyledComponent } from '@emotion/styled';

import { grid, enlargedInputFieldHeight } from '../style-utils';
import type { SearchCSS } from '../theme';
import { DesktopSearchIconWrapper, type IsExpandedProp } from './search-input.styled';

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EnlargedDesktopSearchIconWrapper: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
	} & SearchCSS &
		IsExpandedProp &
		ClassAttributes<HTMLSpanElement> &
		HTMLAttributes<HTMLSpanElement> & {
			theme?: Theme;
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
		},
	{},
	{}
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled(DesktopSearchIconWrapper)<
	SearchCSS & IsExpandedProp
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
>((props) => ({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	width: props.isExpanded ? enlargedInputFieldHeight.half().px : grid.multiple(2).px,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	height: props.isExpanded ? enlargedInputFieldHeight.half().px : grid.multiple(2).px,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	top: props.isExpanded ? grid.multiple(1.5).px : grid.px,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	left: props.isExpanded ? grid.multiple(2).px : grid.px,
	display: 'flex',
	alignItems: 'center',
}));
